import axios from 'axios';

const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH + '/leasemax';
const SCHEDULER_API_PATH =
  process.env.REACT_APP_API_BASE_PATH + '/leasemax/scheduler';

const leasemaxAPIClient = axios.create({
  headers: {
    'd-id': '$eF4&yTg#7',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

//scheduler apis
const TASKS_URL = `${SCHEDULER_API_PATH}/tasks`;
const SCHEDULED_TASKS_URL = `${SCHEDULER_API_PATH}/scheduledTasks`;
const SCHEDULED_TASKS_BY_TASK_ID_URL = `${SCHEDULER_API_PATH}/scheduledTasks/tasks`;
const SCHEDULED_TASKS_BY_ID_URL = `${SCHEDULER_API_PATH}/scheduledTasks`;
const SCHEDULED_TASKS_BY_CLIENT_ID_URL = `${SCHEDULER_API_PATH}/scheduledTasks/client`;
const RUN_SCHEDULED_TASK_URL = `${SCHEDULER_API_PATH}/scheduledTasks/run`;
const CREATE_SCHEDULED_TASK_URL = `${SCHEDULER_API_PATH}/scheduledTasks/create`;
const SETUP_SCHEDULED_TASKS_FOR_CLIENT_URL = `${SCHEDULER_API_PATH}/scheduledTasks/setupClientTasks`;
const SYNC_TIMEZONE_WITH_CLIENT_URL = `${SCHEDULER_API_PATH}/scheduledTasks/syncTimeZoneWithClient`;
const GET_SCHEDULED_JOBS_URL = `${SCHEDULER_API_PATH}/jobs`;
const GET_JOB_EXECUTION_LOGS_URL = `${SCHEDULER_API_PATH}/jobs/executionLogs`;
// const create_scheduled = `${SCHEDULER_API_PATH}/scheduledTasks/syncTimeZoneWithClient`;

// leasemax apis
const GET_ALL_CLIENTS_URL = `${API_BASE_PATH}/getClients`;
const ADD_CLIENT_URL = `${API_BASE_PATH}/addClient`;
const UPDATE_CLIENT_URL = `${API_BASE_PATH}/updateClient`;
const GET_ACTIVE_MODULES = `${API_BASE_PATH}/getAllActiveModules`;
const USER_BY_CLIENT_URL = `${API_BASE_PATH}/getUsersByClient`;
const CREDENTIALS_BY_CLIENT_URL = `${API_BASE_PATH}/getCredentialsByClient`;
const ADD_ENTRATA_CREDENTIALS_URL = `${API_BASE_PATH}/addEntrataCredentials`;
const UPDATE_USER_URL = `${API_BASE_PATH}/updateUserDetails`;
const ADD_USER_URL = `${API_BASE_PATH}/userInvite`;
const GET_MODEL_PARAMETERS = `${API_BASE_PATH}/getClientModelParameters`;
const UPDATE_MODEL_PARAMETERS = `${API_BASE_PATH}/updateClientModelParameters`;

const GET_CLIENT_PROPERTIES = `${API_BASE_PATH}/getClientProperties`;
const GET_CLIENT_MANAGED_PROPERTIES = `${API_BASE_PATH}/getClientManagedProperties`;
const GET_CLIENT_GROUP_OPTIONS = `${API_BASE_PATH}/getClientGroupOptions`;
const GET_CLIENT_GROUP_LIST = `${API_BASE_PATH}/getClientGroupList`;
const GET_CLIENT_USER_LIST = `${API_BASE_PATH}/getClientUserList`;
const ADD_CLIENT_GROUP_URL = `${API_BASE_PATH}/addClientGroup`;
const EXISTING_CLIENT_GROUP_URL = `${API_BASE_PATH}/existingClientGroup`;
const REMOVE_CLIENT_FROM_GROUP_URL = `${API_BASE_PATH}/removeClientFromGroup`;
const EDIT_CLIENT_GROUP_URL = `${API_BASE_PATH}/editClientGroup`;
const ADD_USER_TO_GROUP_URL = `${API_BASE_PATH}/addUserToGroup`;
const REMOVE_USER_FROM_GROUP_URL = `${API_BASE_PATH}/removeUserFromGroup`;
const GET_GROUP_USERS_URL = `${API_BASE_PATH}/getGroupUsers`;

const VALIDATE_AUTH_TOKEN_URL = `${API_BASE_PATH}/validateAuthToken`;
const LOGOUT_URL = `${API_BASE_PATH}/logout`;

export const api = {
  logout: () => {
    return leasemaxAPIClient.get(LOGOUT_URL);
  },
  validateAuthToken: () => {
    return leasemaxAPIClient.get(VALIDATE_AUTH_TOKEN_URL);
  },
  getTasks: () => {
    return leasemaxAPIClient.get(TASKS_URL);
  },
  getTaskById: (id: string) => {
    return leasemaxAPIClient.get(`${TASKS_URL}/${id}`);
  },
  getScheduledTasksByTaskId: (taskId: string) => {
    return leasemaxAPIClient.get(`${SCHEDULED_TASKS_BY_TASK_ID_URL}/${taskId}`);
  },
  getScheduledTaskById: (taskId: string) => {
    return leasemaxAPIClient.get(`${SCHEDULED_TASKS_BY_ID_URL}/${taskId}`);
  },
  getScheduledTaskByClientId: (clientId: string) => {
    return leasemaxAPIClient.get(
      `${SCHEDULED_TASKS_BY_CLIENT_ID_URL}/${clientId}`
    );
  },
  createScheduledTask: (task: any) => {
    return leasemaxAPIClient.post(CREATE_SCHEDULED_TASK_URL, task);
  },
  setupScheduledTasks: (clientId: any) => {
    return leasemaxAPIClient.post(SETUP_SCHEDULED_TASKS_FOR_CLIENT_URL, {
      clientId,
    });
  },
  updateTask: (task: any) => {
    return leasemaxAPIClient.put(`${TASKS_URL}/${task.id}`, task);
  },
  updateScheduledTask: (task: any) => {
    return leasemaxAPIClient.put(`${SCHEDULED_TASKS_URL}/${task.id}`, task);
  },
  runScheduledTask: (id: string, params?: any) => {
    return leasemaxAPIClient.post(
      `${RUN_SCHEDULED_TASK_URL}/${id}`,
      params || {}
    );
  },
  getExecutionLogs: (id: string, page: number = 3, limit: Number = 5) => {
    return leasemaxAPIClient.get(
      `${SCHEDULED_TASKS_URL}/logs/${id}?page=${page}&limit=${limit}`
    );
  },
  getClients: () => {
    return leasemaxAPIClient.get(GET_ALL_CLIENTS_URL);
  },
  addClient: (client: any) => {
    return leasemaxAPIClient.post(ADD_CLIENT_URL, client);
  },
  updateClient: (client: any) => {
    return leasemaxAPIClient.post(UPDATE_CLIENT_URL, client);
  },
  getUIModules: () => {
    return leasemaxAPIClient.get(GET_ACTIVE_MODULES);
  },
  getUsersByClients: (id) => {
    return leasemaxAPIClient.get(`${USER_BY_CLIENT_URL}/${id}`);
  },
  getClientCredentials: (id) => {
    return leasemaxAPIClient.get(`${CREDENTIALS_BY_CLIENT_URL}/${id}`);
  },
  getClientProperties: (id: string) => {
    return leasemaxAPIClient.get(`${GET_CLIENT_PROPERTIES}/${id}`);
  },
  getClientManagedProperties: (id: string) => {
    return leasemaxAPIClient.get(`${GET_CLIENT_MANAGED_PROPERTIES}/${id}`);
  },
  getClientGroupOptions: () => {
    return leasemaxAPIClient.get(GET_CLIENT_GROUP_OPTIONS);
  },
  getClientGroupList: () => {
    return leasemaxAPIClient.get(GET_CLIENT_GROUP_LIST);
  },
  getClientUserList: () => {
    return leasemaxAPIClient.get(GET_CLIENT_USER_LIST);
  },
  addClientGroup: (existingClientId, currentClientId) => {
    return leasemaxAPIClient.post(ADD_CLIENT_GROUP_URL, {
      existingClientId,
      currentClientId,
    });
  },
  existingClientGroup: (GroupId, currentClientId) => {
    return leasemaxAPIClient.put(EXISTING_CLIENT_GROUP_URL, {
      GroupId,
      currentClientId,
    });
  },

  removeClientFromGroup: (ClientId, GroupId) => {
    return leasemaxAPIClient.post(REMOVE_CLIENT_FROM_GROUP_URL, {
      ClientId,
      GroupId,
    });
  },
  addUserToGroup: (UserId, ClientId) => {
    return leasemaxAPIClient.post(ADD_USER_TO_GROUP_URL, { UserId, ClientId });
  },
  removeUserFromGroup: (UserId, ClientId) => {
    return leasemaxAPIClient.post(REMOVE_USER_FROM_GROUP_URL, {
      UserId,
      ClientId,
    });
  },
  getGroupUsers: (ClientId) => {
    return leasemaxAPIClient.get(`${GET_GROUP_USERS_URL}/${ClientId}`);
  },
  editClientGroup: (body) => {
    return leasemaxAPIClient.put(EDIT_CLIENT_GROUP_URL, body);
  },
  addEntrataCredentials: (data) => {
    return leasemaxAPIClient.post(ADD_ENTRATA_CREDENTIALS_URL, data);
  },
  syncTimeZoneWithClient: (data) => {
    return leasemaxAPIClient.post(SYNC_TIMEZONE_WITH_CLIENT_URL, data);
  },
  updateUser: (user) => {
    return leasemaxAPIClient.post(UPDATE_USER_URL, user);
  },
  addUser: (user) => {
    return leasemaxAPIClient.post(ADD_USER_URL, user);
  },
  getClientModelParameters: (clientId: string) => {
    return leasemaxAPIClient.get(`${GET_MODEL_PARAMETERS}/${clientId}`);
  },
  getSystemSettings: (clientId) => {
    return leasemaxAPIClient.get(
      `${API_BASE_PATH}/admin/settings?clientId=${clientId}`
    );
  },
  addSystemSettings: (settingData, clientId) => {
    return leasemaxAPIClient.post(
      `${API_BASE_PATH}/admin/settings?clientId=${clientId}`,
      settingData
    );
  },
  updateSetting: (settingData, clientId) => {
    const {
      Key: key,
      Value: value,
      Description: description,
      Name: name,
      id,
      IsActive: isActive,
    } = settingData;
    return leasemaxAPIClient.put(
      `${API_BASE_PATH}/admin/settings?clientId=${clientId}`,
      {
        key,
        value,
        name,
        description,
        isActive,
        id,
      }
    );
  },
  updateClientModelParameters: (data) => {
    return leasemaxAPIClient.put(UPDATE_MODEL_PARAMETERS, data);
  },
  login: (data) => {
    return leasemaxAPIClient.post(`${API_BASE_PATH}/userSignIn`, data);
  },
  addYardiSippCredentials: (data) => {
    return leasemaxAPIClient.post(
      `${API_BASE_PATH}/yardi-interface-credentials`,
      data
    );
  },
  getScheduledJobs: () => {
    return leasemaxAPIClient.get(GET_SCHEDULED_JOBS_URL);
  },
  getJobExecutionLogs: (clientId, startDate) => {
    return leasemaxAPIClient.get(
      `${GET_JOB_EXECUTION_LOGS_URL}?${
        clientId ? `clientId=${clientId}&` : ''
      }startDate=${startDate}`
    );
  },
  getPropertySettings: (clientId, propertyId) => {
    return leasemaxAPIClient.get(
      `${API_BASE_PATH}/admin/settings/property?clientId=${clientId}&propertyCode=${propertyId}`
    );
  },
  updatePropertySetting: (setting, clientId, propertyId) => {
    const { Key: key, Value: value } = setting;
    return leasemaxAPIClient.put(
      `${API_BASE_PATH}/admin/settings/property?clientId=${clientId}&propertyCode=${propertyId}`,
      {
        key,
        value,
      }
    );
  },
  resetPropertySettings: (clientId, propertyId) => {
    return leasemaxAPIClient.delete(
      `${API_BASE_PATH}/admin/settings/${propertyId}/reset?clientId=${clientId}`
    );
  },

  updateEntrataCredentials: (data) => {
    return leasemaxAPIClient.put(
      `${API_BASE_PATH}/updateEntrataCredentials`,
      data
    );
  },
  updateYardiSippCredentials: (data) => {
    return leasemaxAPIClient.put(
      `${API_BASE_PATH}/yardi-interface-credentials`,
      data
    );
  },
  addSFTPCredentials: ({ data, clientId }) => {
    return leasemaxAPIClient.post(
      `${API_BASE_PATH}/sftp-credentials/${clientId}`,
      { ...data, ClientId: clientId }
    );
  },
  updateSFTPCredentials: (data) => {
    return leasemaxAPIClient.put(`${API_BASE_PATH}/sftp-credentials`, data);
  },
};
